// Auto-generated by scripts/permissions/generateRoutePermissions.js. Do not edit manually.

export const PERMISSIONS = {
  InvoiceCreate: 'invoice.create',
  InvoiceRead: 'invoice.read',
  InvoiceUpdate: 'invoice.update',
  InvoiceDelete: 'invoice.delete',
  InvoiceList: 'invoice.list',
  UsersInvite: 'user.create',
  UserRead: 'user.read',
  UserUpdate: 'user.update',
  UserDelete: 'user.delete',
  UsersView: 'user.list',
  UserroleAssign: 'userrole.assign',
  UserroleRevoke: 'userrole.revoke',
  ApikeyCreate: 'apikey.create',
  ApikeyRead: 'apikey.read',
  ApikeyUpdate: 'apikey.update',
  ApikeyDelete: 'apikey.delete',
  ApikeyList: 'apikey.list',
  PaymentRead: 'payment.read',
  PaymentList: 'payment.list',
  PaymentFlag: 'payment.flag',
  OrganizationCreate: 'organization.create',
  OrganizationRead: 'organization.read',
  OrganizationList: 'organization.list',
  OrganizationUpdate: 'organization.update',
  OrganizationApprove: 'organization.approve',
  RoleCreate: 'role.create',
  RoleRead: 'role.read',
  RoleUpdate: 'role.update',
  RoleDelete: 'role.delete',
  RoleList: 'role.list',
  PermissionRead: 'permission.read',
  PermissionList: 'permission.list',
  PermissionroleAssign: 'permissionrole.assign',
  PermissionroleRevoke: 'permissionrole.revoke',
  PermissiongroupRead: 'permissiongroup.read',
  PermissiongroupList: 'permissiongroup.list',
  PermissiongroupUpdate: 'permissiongroup.update',
  PaymentproviderCreate: 'paymentprovider.create',
  PaymentproviderRead: 'paymentprovider.read',
  PaymentproviderUpdate: 'paymentprovider.update',
  PaymentproviderDelete: 'paymentprovider.delete',
  PaymentproviderList: 'paymentprovider.list',
  PaymentprovidercardtypeCreate: 'paymentprovidercardtype.create',
  PaymentprovidercardtypeRead: 'paymentprovidercardtype.read',
  PaymentprovidercardtypeUpdate: 'paymentprovidercardtype.update',
  PaymentprovidercardtypeDelete: 'paymentprovidercardtype.delete',
  PaymentprovidercardtypeList: 'paymentprovidercardtype.list',
  PaymentproviderpaymenttypeCreate: 'paymentproviderpaymenttype.create',
  PaymentproviderpaymenttypeRead: 'paymentproviderpaymenttype.read',
  PaymentproviderpaymenttypeUpdate: 'paymentproviderpaymenttype.update',
  PaymentproviderpaymenttypeDelete: 'paymentproviderpaymenttype.delete',
  PaymentproviderpaymenttypeList: 'paymentproviderpaymenttype.list',
  RefundCreate: 'refund.create',
  RefundRead: 'refund.read',
  RefundUpdate: 'refund.update',
  RefundList: 'refund.list',
  RefundApprove: 'refund.approve',
  RefundDeny: 'refund.deny',
  RefundManage: 'refund.manage',
  ApipaymentRead: 'apipayment.read',
  ApipaymentList: 'apipayment.list',
  RecurringpaymentCreate: 'recurringpayment.create',
  RecurringpaymentRead: 'recurringpayment.read',
  RecurringpaymentUpdate: 'recurringpayment.update',
  RecurringpaymentDelete: 'recurringpayment.delete',
  RecurringpaymentList: 'recurringpayment.list',
  RecurringpaymentManage: 'recurringpayment.manage',
  PolicyCreate: 'policy.create',
  PolicyRead: 'policy.read',
  PolicyUpdate: 'policy.update',
  PolicyDelete: 'policy.delete',
  PolicyList: 'policy.list',
  PolicyAccept: 'policy.accept',
  MerchantbankaccountCreate: 'merchantbankaccount.create',
  MerchantbankaccountRead: 'merchantbankaccount.read',
  MerchantbankaccountUpdate: 'merchantbankaccount.update',
  MerchantbankaccountDelete: 'merchantbankaccount.delete',
  MerchantbankaccountList: 'merchantbankaccount.list',
  MerchantbankaccountAdministration: 'merchantbankaccount.administration',
  MerchantbankaccountClose: 'merchantbankaccount.close',
  PayoutRead: 'payout.read',
  PayoutList: 'payout.list',
  PayoutCreate: 'payout.create',
  PayoutUpdate: 'payout.update',
  PayoutDelete: 'payout.delete',
  EventRead: 'event.read',
  EventList: 'event.list',
  DisputeRead: 'dispute.read',
  DisputeList: 'dispute.list',
  DisputeCreate: 'dispute.create',
  DisputeUpdate: 'dispute.update',
  TransferRead: 'transfer.read',
  TransferList: 'transfer.list',
  TransferCreate: 'transfer.create',
  TransferUpdate: 'transfer.update',
  TransferDelete: 'transfer.delete',
  LogsRead: 'logs.read',
  LogsList: 'logs.list',
  QuickpayRead: 'quickpay.read',
  QuickpayList: 'quickpay.list',
  QuickpayCreate: 'quickpay.create',
  QuickpayUpdate: 'quickpay.update',
  QuickpayArchive: 'quickpay.archive',
  QuickpayActivate: 'quickpay.activate',
  QuickpayPause: 'quickpay.pause',
} as const;

export type PermissionSlug = (typeof PERMISSIONS)[keyof typeof PERMISSIONS];

export const ROUTE_PERMISSIONS = {
  payments: [PERMISSIONS.PaymentList],
  payLinksCreate: [PERMISSIONS.InvoiceCreate],
  payLinksDetail: [PERMISSIONS.InvoiceRead],
  quickPay: [PERMISSIONS.QuickpayList],
  quickPayCreate: [PERMISSIONS.QuickpayCreate],
  quickPayDetail: [PERMISSIONS.QuickpayRead],
  recurringPayment: [],
  recurringPaymentDetail: [],
  checkouts: [PERMISSIONS.ApipaymentList],
  payouts: [PERMISSIONS.ApipaymentList],
  refunds: [PERMISSIONS.RefundList],
  refundsDetail: [PERMISSIONS.RefundRead],
  refundsDecline: [PERMISSIONS.RefundDeny],
  disputes: [PERMISSIONS.DisputeList],
  reports: [PERMISSIONS.PaymentList],
  notifications: [],
  users: [PERMISSIONS.UserRead],
  userInvite: [PERMISSIONS.UsersInvite],
  merchants: [PERMISSIONS.OrganizationList],
  // Bank management is platform-wide administration, so routes also sit
  // behind PlatformOnlyGuard. Once the backend exposes bank.* permission
  // slugs, swap these for bank.list / bank.create / bank.update.
  banks: [PERMISSIONS.OrganizationList],
  developers: [PERMISSIONS.ApikeyList],
  gateways: [PERMISSIONS.PaymentproviderList],
  roles: [PERMISSIONS.RoleList],
  transfers: [PERMISSIONS.TransferList],
  transferDetail: [PERMISSIONS.TransferRead],
} satisfies Record<string, PermissionSlug[]>;

export const MENU_PERMISSIONS: Record<string, PermissionSlug[]> = {
  payments: ROUTE_PERMISSIONS.payments,
  transactions: [],
  payLinks: ROUTE_PERMISSIONS.payLinksDetail,
  quickPay: ROUTE_PERMISSIONS.quickPay,
  checkouts: ROUTE_PERMISSIONS.checkouts,
  refunds: ROUTE_PERMISSIONS.refunds,
  disputes: ROUTE_PERMISSIONS.disputes,
  reports: ROUTE_PERMISSIONS.reports,
  users: ROUTE_PERMISSIONS.users,
  merchants: ROUTE_PERMISSIONS.merchants,
  banks: ROUTE_PERMISSIONS.banks,
  developers: ROUTE_PERMISSIONS.developers,
  webhooks: [],
  gatewaySettings: ROUTE_PERMISSIONS.gateways,
  payouts: ROUTE_PERMISSIONS.payouts,
  transfers: ROUTE_PERMISSIONS.transfers,
};

